import type { BaseDataItem, VariantDataItem } from '@wix/thunderbolt-becky-types'

export type VariantViewDataItem = VariantDataItem

export type VariantRelationViewItem<T> = BaseDataItem<'VariantRelation'> & {
	from: string
	to: T
	variants: Array<VariantViewDataItem>
}

export type RefArrayViewItem<T> = BaseDataItem<'RefArray'> & {
	values: Array<T | VariantRelationViewItem<T>>
}

export type InflatedRefArrayViewItemValues<T> = T | VariantRelationViewItem<T> | InflatedRefArrayViewItem<T>

export type InflatedRefArrayViewItem<T> = BaseDataItem<'RefArray'> & {
	values: Array<InflatedRefArrayViewItemValues<T>>
}

export const isRefArrayViewItem = <T extends BaseDataItem>(item?: BaseDataItem): item is RefArrayViewItem<T> =>
	item?.type === 'RefArray'

export type CompVariantsViewItem = { [variantId: string]: VariantDataItem }
